import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  message,
} from "antd";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { collection, doc, setDoc, updateDoc } from "firebase/firestore";
import TreeMultiSelect from "../../../../components/common/TreeSelect";
import { glAccounts } from "../../../../data/accounting";
import { checks } from "../../../../utils/tenants";
import { db } from "../../../../firebase";
import FormAction from "../../../../components/common/FormAction";

function AccountingInformation({ data, peopleType, renderData, companyName }) {
  const [checked, setChecked] = useState(false);
  const [value, setValue] = useState("discount");

  console.log("AccountingInformation Data", data);

  // const [form] = Form.useForm();
  const { id } = useParams();

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const onFinish = async (values) => {
    // console.log("AccountingInformation Success", values);
    // form.setFieldsValue(values);
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const ownerRef = collection(companyDocRef, "owners");

    try {
      await updateDoc(doc(ownerRef, id), {
        accountingInfo: values,
      });
      message.success("Accounting Information Updated SuccessFully!");
      setChecked(false);
      renderData(true);
    } catch (err) {
      console.error(err);
      message.error(err.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Accounting Information Updated Failed!");
  };
  const onCancel = () => {
    setChecked(false);
  };
  const defaultValues = {
    consolidateChecks: data?.consolidateChecks ? data?.consolidateChecks : "-",
    defaultCheckMemo: data?.defaultCheckMemo ? data?.defaultCheckMemo : " ",
    emailCheckReceipt: data?.emailCheckReceipt
      ? data?.emailCheckReceipt
      : false,
    holdPayments: data?.holdPayments ? data?.holdPayments : false,
  };
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Accounting Information"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <div>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                  labelWrap={{ span: 8 }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={defaultValues}
                >
                  <Form.Item
                    label="Consolidate Checks"
                    name="consolidateChecks"
                  >
                    <Select options={checks} placeholder="Select..." />
                  </Form.Item>
                  <Form.Item
                    label="Hold Payments"
                    name="holdPayments"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Email eCheck Receipt?"
                    name="emailCheckReceipt"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  {peopleType === "Vendor" ? (
                    <Form.Item label="Payment Terms" name="Consolidate">
                      <Select options={checks} placeholder="Select..." />
                    </Form.Item>
                  ) : null}
                  <Form.Item label="Default Check Memo" name="defaultCheckMemo">
                    <Input />
                  </Form.Item>
                  {peopleType === "Vendor" ? (
                    <>
                      <Form.Item label="Default GL Account" name="Consolidate">
                        <TreeMultiSelect
                          options={glAccounts}
                          placeholder="Select...."
                        />
                      </Form.Item>
                      <Form.Item
                        label="Work Order Adjustment"
                        required
                        name="Consolidate"
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item label="Adjustment Type" name="Consolidate">
                        <Space>
                          <Radio.Group onChange={onChange} value={value}>
                            <Radio value="discount">Discount</Radio>
                            <Radio value="markup">Markup</Radio>
                          </Radio.Group>
                        </Space>
                      </Form.Item>
                    </>
                  ) : null}

                  <FormAction
                    className="contact-actions"
                    submit={"submit"}
                    cancel={onCancel}
                  />
                </Form>
              </Col>
            </div>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Check Consolidation">
                <p>
                  {data?.consolidateChecks ? data?.consolidateChecks : "--"}
                </p>
              </Form.Item>
              <Form.Item label="Hold Payments">
                <p>{data?.holdPayments ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Email eCheck Receipt?">
                <p>{data?.emailCheckReceipt ? "Yes" : "No"}</p>
              </Form.Item>
              {peopleType === "Vendor" ? (
                <Form.Item label="Payment Terms">
                  <p>--</p>
                </Form.Item>
              ) : null}
              <Form.Item label="Default Check Memo">
                <p>{data?.defaultCheckMemo ? data?.defaultCheckMemo : "--"}</p>
              </Form.Item>
              {peopleType === "Vendor" ? (
                <>
                  <Form.Item label="Default GL Account">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Work Order Adjustment">
                    <p>--</p>
                  </Form.Item>
                </>
              ) : null}
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default AccountingInformation;
